import ArtStage from './ArtStage';
import ArtStageContainer from './ArtStage.container';
export default ArtStageContainer(ArtStage);
